/* ============================================================
   TITAN SLIM — Camiseta de compresión masculina (slug 'titanslim').
   OJO: no confundir con la landing 'titan' (botas de seguridad).

   Producto Shopify "CAMISILLA DE COMPRESION" (8649568616609) con 12
   variantes REALES TALLAS x COLORES mapeadas 1:1 con Dropi. Por eso los
   packs NO son variantes: son la MISMA variante talla+color con quantity N
   + un descuento automático de Shopify que ajusta el total:
     1 Titan Slim        -> qty 1 = $79.900
     2 + 1 GRATIS (3 uds)-> qty 3 = $239.700 - $89.800 = $149.900
   El pedido llega a Dropi como "TALLA/COLOR x 3" y despacha 3 camisetas.
   Requiere quantityControlsHidden:true en Releasit (ya global) para que el
   cliente no pueda cambiar la cantidad y desarmar el precio.

   Match de variante por (talla, color) — NUNCA por SKU: Dropi re-SKUea al
   reimportar. Ver memory/project_northpower_landing y
   memory/feedback_dropi_resku_variant_match.
   ============================================================ */
(function () {
  var root = document.querySelector('.titanslim-landing');
  if (!root) return;

  /* ============================================================
     1. Galería (thumbs -> imagen principal)
     ============================================================ */
  var mainImg = document.getElementById('mainImg');
  root.querySelectorAll('#thumbs .thumb').forEach(function (t) {
    t.addEventListener('click', function () {
      root.querySelectorAll('#thumbs .thumb').forEach(function (x) { x.classList.remove('is-active'); });
      t.classList.add('is-active');
      var img = t.querySelector('img');
      if (mainImg && img) mainImg.src = img.src;
    });
  });

  /* ============================================================
     2. Releasit COD — variante + cantidad en el DOM, click botón nativo
     ============================================================ */
  var RELEASIT_SELECTORS = [
    '#rsi_buy_now_button',
    '.rsi_buy_now_button',
    '._rsi-buy-now-button',
    '._rsi-buy-now-button-app-block-hook button',
    '._rsi-buy-now-button-app-block-hook a',
    '.rsi-btn-skel'
  ];

  function findReleasitButton() {
    for (var i = 0; i < RELEASIT_SELECTORS.length; i++) {
      var el = document.querySelector(RELEASIT_SELECTORS[i]);
      if (el) return el;
    }
    return null;
  }

  function setVariantOnAllForms(variantId, qty) {
    if (!variantId) return;
    var q = parseInt(qty, 10);
    if (!q || q < 1) q = 1;
    document.querySelectorAll('form[action="/cart/add"] input[name="id"]').forEach(function (input) {
      input.value = variantId;
    });
    document.querySelectorAll('input[name="product-id"]').forEach(function (input) {
      input.value = variantId;
    });
    // Releasit lee la cantidad de input[name="quantity"] al abrir el modal
    document.querySelectorAll('input[name="quantity"]').forEach(function (input) {
      input.value = String(q);
      input.setAttribute('value', String(q));
    });
    if (window.productData) { window.productData.quantity = q; }
    if (window.productData && Array.isArray(window.productData.variants)) {
      var v = window.productData.variants.find(function (x) { return String(x.id) === String(variantId); });
      if (v) {
        window.productData.selected_or_first_available_variant = v;
        window.productData.selected_variant = v;
        try {
          document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
          document.dispatchEvent(new CustomEvent('product:variant-change', { detail: { variant: v } }));
        } catch (e) {}
      }
    }
  }

  function clickNativeReleasit() {
    var rb = findReleasitButton();
    if (rb) { rb.click(); return; }
    var attempts = 0;
    var poll = setInterval(function () {
      attempts++;
      var b = findReleasitButton();
      if (b) { clearInterval(poll); b.click(); return; }
      if (attempts > 30) {
        clearInterval(poll);
        // último recurso: abre el modal con la variante que Releasit cacheó
        if (window._rsiV2 && typeof window._rsiV2.setState === 'function') {
          try { window._rsiV2.setState({ isOpen: true }); } catch (e) {}
        }
      }
    }, 100);
  }

  /* ============================================================
     3. Estado de compra: pack (cantidad) + talla + color
     ============================================================ */
  var VARIANTS = Array.isArray(window.TS_VARIANTS) ? window.TS_VARIANTS : [];
  var elTalla = document.getElementById('ts-talla');
  var elColor = document.getElementById('ts-color');
  var elSold = document.getElementById('ts-soldout');
  var elNow = root.querySelector('.price .now');
  var elWas = root.querySelector('.price .was');
  var elOff = root.querySelector('.price .off');

  var selTalla = elTalla ? elTalla.value : null;
  var selColor = elColor ? elColor.value : null;
  var selQty = 3;                 // arranca en el pack más vendido (2+1 gratis)

  function findVar(talla, color) {
    return VARIANTS.find(function (v) { return v.talla === talla && v.color === color; });
  }
  function currentVariant() { return findVar(selTalla, selColor); }

  function refresh() {
    var v = currentVariant();
    if (v) {
      setVariantOnAllForms(v.id, selQty);
      if (elSold) elSold.style.display = v.available ? 'none' : 'block';
    } else if (elSold) {
      elSold.style.display = 'block';
    }
  }

  root.querySelectorAll('[data-pack]').forEach(function (p) {
    p.addEventListener('click', function (e) {
      if (e.target.tagName === 'SELECT') return;
      root.querySelectorAll('[data-pack]').forEach(function (x) { x.classList.remove('is-active'); });
      p.classList.add('is-active');
      selQty = parseInt(p.getAttribute('data-qty'), 10) || 1;
      if (elNow && p.dataset.total) elNow.textContent = p.dataset.total;
      if (elWas && p.dataset.was) elWas.textContent = p.dataset.was;
      if (elOff && p.dataset.off) elOff.textContent = p.dataset.off;
      refresh();
    });
  });

  if (elTalla) elTalla.addEventListener('change', function () { selTalla = elTalla.value; refresh(); });
  if (elColor) elColor.addEventListener('change', function () { selColor = elColor.value; refresh(); });

  window.titanslimTriggerCOD = function () {
    var v = currentVariant();
    if (!v) { alert('Elige talla y color.'); return; }
    if (!v.available) {
      if (elSold) elSold.style.display = 'block';
      return;
    }
    setVariantOnAllForms(v.id, selQty);
    setTimeout(clickNativeReleasit, 50);
  };

  /* todos los CTA de compra abren el modal COD con el pack activo */
  root.querySelectorAll('.js-cod').forEach(function (btn) {
    btn.addEventListener('click', function () { window.titanslimTriggerCOD(); });
  });

  refresh();

  /* ============================================================
     4. Acordeones (info del producto + FAQ)
     ============================================================ */
  function wireAcc(scopeSel, itemSel, qSel, aSel) {
    root.querySelectorAll(scopeSel + ' ' + itemSel).forEach(function (it) {
      var q = it.querySelector(qSel), a = it.querySelector(aSel);
      if (!q || !a) return;
      q.addEventListener('click', function () {
        if (it.classList.contains('open')) {
          it.classList.remove('open');
          a.style.maxHeight = null;
        } else {
          it.classList.add('open');
          a.style.maxHeight = a.scrollHeight + 'px';
        }
      });
    });
  }
  wireAcc('#infoAcc', '.acc__item', '.acc__q', '.acc__a');
  wireAcc('#faqBox', '.faqitem', '.faqitem__q', '.faqitem__a');

  /* ============================================================
     5. Rotador de mini reseñas
     ============================================================ */
  var minis = [
    ['Pensé que apretaría demasiado, pero es súper cómoda y no se nota nada bajo la ropa.', 'Marcos'],
    ['La barriga se disimula al instante y me mejora la postura. No esperaba tanto.', 'Lucas'],
    ['Mi duda era si se vería… y para nada. Queda completamente invisible y estiliza un montón.', 'Alejandro']
  ];
  var mi = 0, miniEl = document.getElementById('miniReview');
  if (miniEl) {
    setInterval(function () {
      mi = (mi + 1) % minis.length;
      miniEl.innerHTML = '<p class="mini__q"></p><div class="mini__n"><span> </span><span class="stars">★★★★★</span></div>';
      miniEl.querySelector('.mini__q').textContent = minis[mi][0];
      miniEl.querySelector('.mini__n span').textContent = minis[mi][1] + ' ';
    }, 4000);
  }

  /* ============================================================
     6. Slider antes/después
     ============================================================ */
  (function () {
    var ba = document.getElementById('ba');
    var after = document.getElementById('baAfter');
    var line = document.getElementById('baLine');
    var handle = document.getElementById('baHandle');
    if (!ba || !after || !line || !handle) return;
    var drag = false;
    function set(x) {
      var r = ba.getBoundingClientRect();
      var p = (x - r.left) / r.width;
      p = Math.max(0, Math.min(1, p));
      after.style.clipPath = 'inset(0 0 0 ' + (p * 100) + '%)';
      line.style.left = (p * 100) + '%';
      handle.style.left = (p * 100) + '%';
    }
    handle.addEventListener('mousedown', function () { drag = true; });
    window.addEventListener('mouseup', function () { drag = false; });
    window.addEventListener('mousemove', function (e) { if (drag) set(e.clientX); });
    ba.addEventListener('click', function (e) { set(e.clientX); });
    handle.addEventListener('touchmove', function (e) { set(e.touches[0].clientX); }, { passive: true });
  })();

  /* ============================================================
     7. Carrusel de testimonios
     ============================================================ */
  var track = document.getElementById('caroTrack');
  var caroL = document.getElementById('caroL'), caroR = document.getElementById('caroR');
  if (track && caroL && caroR) {
    caroL.addEventListener('click', function () { track.scrollBy({ left: -340, behavior: 'smooth' }); });
    caroR.addEventListener('click', function () { track.scrollBy({ left: 340, behavior: 'smooth' }); });
  }

  /* ============================================================
     8. Modal guía de tallas
     ============================================================ */
  var sm = document.getElementById('sizeModal');
  var smBtn = document.getElementById('sizeGuideBtn');
  if (sm && smBtn) {
    smBtn.addEventListener('click', function () { sm.classList.add('open'); });
    sm.addEventListener('click', function (e) {
      if (e.target === sm || e.target.hasAttribute('data-close')) sm.classList.remove('open');
    });
  }
})();
